/**
 * The types of members.
 */
export const MemberType = {
  /**
   * A message from the agent.
   */
  AGENT: 'agent',
  /**
   * A message from the visitor.
   */
  VISITOR: 'visitor',
} as const;
